import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';

const FuturesAppropriatenessTestIntroLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('FuturesAppropriatenessAssessment.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('FuturesAppropriatenessAssessment.description')}</PageHeadingDescription>
      </legend>
    </PageHeading>
  );
};
FuturesAppropriatenessTestIntroLegend.displayName = 'FuturesAppropriatenessTestIntroLegend';

const FuturesAppropriatenessTestIntro = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <p>{t('FuturesAppropriatenessAssessment.info.intro')}</p>
      <p>{t('FuturesAppropriatenessAssessment.info.questions.intro')}</p>
      <ul className="list-disc pl-8 space-y-2">
        {(t('FuturesAppropriatenessAssessment.info.questions.questions', { returnObjects: true }) as string[]).map((question, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: index matches translation index
          <li key={index}>{question}</li>
        ))}
      </ul>
      <p>{t('FuturesAppropriatenessAssessment.info.questions.closing')}</p>
      <p>{t('FuturesAppropriatenessAssessment.info.closing')}</p>
    </div>
  );
};
FuturesAppropriatenessTestIntro.displayName = 'FuturesAppropriatenessTestIntro';

export { FuturesAppropriatenessTestIntro, FuturesAppropriatenessTestIntroLegend };
